import React from 'react';
import Svg, { Path } from 'react-native-svg';
import { IconProps } from 'shared/components/vxl/icon/Icon/Icon';

export default function Tips({
  iconColor,
  iconSize,
  iconAccessibilityLabel,
}: IconProps) {
  return (
    <Svg
      accessibilityLabel={iconAccessibilityLabel}
      width={iconSize}
      height={iconSize}
      viewBox="0 0 24 24"
    >
      <Path
        d="M17.85 12.88C17.85 13.6533 17.226 14.0853 16.3673 14.0853C15.3326 14.0853 14.746 13.6266 14.7193 12.8213H15.4766C15.53 13.28 15.7913 13.4613 16.3353 13.4613C16.73 13.4613 17.0766 13.3226 17.0766 12.9706C17.0766 12.6055 16.7297 12.5261 16.1707 12.398L16.1326 12.3893C15.45 12.2346 14.826 12.0533 14.826 11.2586C14.826 10.5066 15.4393 10.1173 16.2873 10.1173C17.146 10.1173 17.7006 10.5386 17.7593 11.3066H17.018C16.9753 10.9226 16.6766 10.7306 16.282 10.7306C15.866 10.7306 15.594 10.9066 15.594 11.1786C15.594 11.488 15.8606 11.5786 16.426 11.7013C17.21 11.872 17.85 12.0586 17.85 12.88Z"
        fill={iconColor}
      />
      <Path
        d="M7.81325 10.8373H6.66659V10.1866H9.73325V10.8373H8.58659V14H7.81325V10.8373Z"
        fill={iconColor}
      />
      <Path d="M10.903 14H10.1297V10.1866H10.903V14Z" fill={iconColor} />
      <Path
        d="M11.4941 14H12.2941V12.6186H13.2328C14.0328 12.6186 14.5075 12.1333 14.5075 11.4133C14.5075 11.0613 14.3795 10.7626 14.1661 10.544C13.9421 10.3146 13.6115 10.1866 13.1688 10.1866H11.4941V14ZM12.2941 10.8586H13.1048C13.4888 10.8586 13.7128 11.0613 13.7128 11.4186C13.7128 11.7653 13.4995 11.9893 13.0941 11.9893H12.2941V10.8586Z"
        fill={iconColor}
      />
      <Path
        d="M1.33325 12C1.33325 6.10894 6.10888 1.33331 11.9999 1.33331C17.891 1.33331 22.6666 6.10894 22.6666 12C22.6666 17.891 17.891 22.6666 11.9999 22.6666C6.10888 22.6666 1.33325 17.891 1.33325 12ZM11.9999 2.66665C6.84526 2.66665 2.66659 6.84532 2.66659 12C2.66659 14.3374 3.5258 16.4741 4.94561 18.1115L7.72379 15.3333H9.60941L5.88842 19.0543C7.52583 20.4741 9.66254 21.3333 11.9999 21.3333C17.1546 21.3333 21.3333 17.1546 21.3333 12C21.3333 9.6626 20.474 7.52589 19.0542 5.88848L16.2761 8.66665H14.3905L18.1114 4.94567C16.474 3.52586 14.3373 2.66665 11.9999 2.66665Z"
        fill={iconColor}
      />
    </Svg>
  );
}
